import{AccessibleIcon as o}from"@radix-ui/react-accessible-icon";export{o as AccessibleIcon};
//# sourceMappingURL=accessible-icon.js.map
